import styled from 'styled-components'
import { background, border, layout, position, space } from 'styled-system'

const Box = styled.div`
  ${background}
  ${border}
  ${layout}
  ${position}
  ${space}
`

export default Box
